import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import getCTAProps from '@utils/cta';
import Block from '@components/block/Text/Block';
import Button from '@components/Button';
import VideoPlayer from '@components/VideoPlayer';

import * as styled from './styles';
import { RoughOne, RoughThree, Swirl2 } from '../../vector';

function VideoTextBlock(props) {
  const {
    title,
    titleTheme,
    text,
    button,
    videoAlignment,
    videoOrientation,
    videoUrl,
    videoCover,
    type,
    decoratedSwirl,
  } = props;
  const getAspectRatio = (orientation) =>
    orientation === 'portrait' ? 3 / 4 : 16 / 9;
  return (
    <styled.Wrapper colorTheme={titleTheme}>
      <styled.StaggeredInner type={type} colorTheme={titleTheme}>
        <RoughThree />
        <RoughOne />
      </styled.StaggeredInner>
      <styled.Inner align={videoAlignment}>
        <styled.VideoContainer orientation={videoOrientation}>
          <styled.VideoWrapper orientation={videoOrientation}>
            <div style={{ aspectRatio: String(getAspectRatio(videoOrientation)) }}>
              <VideoPlayer videoUrl={videoUrl} thumbnailUrl={videoCover.asset.url} />
            </div>
          </styled.VideoWrapper>
        </styled.VideoContainer>

        <styled.Content colorTheme={titleTheme}>
          <styled.Title colorTheme={titleTheme} levels={[200]}>
            {title}
          </styled.Title>
          {decoratedSwirl && <Swirl2 />}
          {Array.isArray(text) &&
            text.map((part, idx) => (
              <styled.TextWrapper key={idx}>
                <Block content={part} />
              </styled.TextWrapper>
            ))}
          {get(button, 'label') && (
            <Button appearance={button.colorTheme} fill {...getCTAProps(button)}>
              {button.label}
            </Button>
          )}
        </styled.Content>
      </styled.Inner>
    </styled.Wrapper>
  );
}

VideoTextBlock.propTypes = {
  title: PropTypes.string,
  titleTheme: PropTypes.oneOf(['blue', 'green', 'orange', 'purple', 'yellow']),
  type: PropTypes.oneOf(['plain', 'staggered']),
  decoratedSwirl: PropTypes.bool,
  text: PropTypes.arrayOf(PropTypes.any),
  button: PropTypes.shape({
    label: PropTypes.string,
    link: PropTypes.string,
    colorTheme: PropTypes.oneOf(['blue', 'green', 'orange', 'purple', 'yellow']),
  }),
  videoAlignment: PropTypes.oneOf(['right', 'left']),
  videoOrientation: PropTypes.oneOf(['album', 'portrait']),
  videoUrl: PropTypes.string,
  videoCover: PropTypes.shape({
    asset: PropTypes.shape({
      url: PropTypes.string,
    }),
  }),
};


VideoTextBlock.defaultProps = {
  videoAlignment: 'right',
  videoOrientation: 'album',
  decoratedSwirl: false,
  type: 'plain',
};

export default VideoTextBlock;
